import React, { useEffect } from "react";
import styles from "./Activity.module.sass";
import Loader from "../../Loader";
import Row from "./row";
import { UseApi } from "../../../hooks/use-api";
import { GetActivity, GetEvents } from "../../../Services/lib/nft";
import Empthy from "../../Empty";

const Activity = ({ item }) => {
	const [{ data, isLoading }, fetch] = UseApi({
		service: GetEvents,
	});

	useEffect(() => {
		if (item) {
			fetch({
				nft: item._id,
			});
		}
	}, [item]);

	return (
		<div className={styles.wrapper}>
			<div className={styles.table}>
				<div className={styles.row}>
					<div className={styles.col}>type</div>
					<div className={styles.col}>From</div>
					<div className={styles.col}>To</div>
					<div className={styles.col}>Price</div>
					<div className={styles.col}>Date</div>
				</div>
				{isLoading ? (
					<div className={styles.loaderWrap}>
						<Loader className={styles.loader} />
					</div>
				) : data && data.length > 0 ? (
					data.map((e) => <Row key={e._id} item={e} />)
				) : (
					<Empthy />
				)}
			</div>
			{/* <div className={styles.foot}>
				<button className={cn("button-stroke button-small", styles.button)}>
					<Loader className={styles.loader} />
					<span>Load more</span>
				</button>
			</div> */}
		</div>
	);
};

export default Activity;
